import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyapphomebodyadminroles} from './/bodyapphomebodyadminroles'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappadminroles extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyapphomebodyadminroles/>
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappadminroles);